import { useEffect, useState } from 'react';

export function useDuration(startTime, tickMs = 1000) {
  const start = startTime ? new Date(startTime).getTime() : null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!start) return undefined;
    const id = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [start, tickMs]);

  if (!start || Number.isNaN(start)) {
    return { totalSeconds: 0, minutes: 0, hours: 0, formatted: '00:00:00' };
  }
  const elapsed = Math.max(0, Math.floor((now - start) / 1000));
  const hours = Math.floor(elapsed / 3600);
  const minutes = Math.floor(elapsed / 60);
  const ss = elapsed % 60;
  const mm = Math.floor((elapsed % 3600) / 60);
  const formatted = `${String(hours).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
  return { totalSeconds: elapsed, minutes, hours, formatted };
}
